// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { LibAction } from '../core/action';
import { Buffer, AggregationBuffer } from '../core/buffer';
import { ConsumerService } from '../core/consumer';
import { SpzaInstrumentService } from '../spza/spzaInstrument';
import { Constants } from '../../../utils/constants';
import { getAppConfig } from '../../init/appConfig';
import { getWindow } from '../../../services/window';
import { logger } from '@src/logger';
const PUBLISH_RETRY_COUNT = 2;
class TelemetryActions extends LibAction {
    initSystemInfo(probeName, service) {
        service.systemInfo.correlationId = getAppConfig('correlationId');
    }
    loggerFlush(probeName, service) {
        const buffer = service.buffer;
        const events = [];
        if (buffer && buffer.getSize() > 0) {
            while(!buffer.isEmpty()){
                const event = buffer.pop().data;
                events.push(event);
            }
            const correlationId = getAppConfig('correlationId');
            const telemetryPayload = {
                events,
                correlationId
            };
            service.action.publishTelemetryEvent(telemetryPayload);
        }
    }
    serverLogInfoMessageEvent(probeName, service, payload) {
        if (payload.actionModifier === Constants.Telemetry.ActionModifier.Error) {
            service.action.logHelper.Logger.logError(payload.action, payload.details, '');
            logger.error(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier,
                appName: payload.appName,
                page: payload.page
            });
        } else {
            service.action.logHelper.Logger.logInfoMessage(payload.action, payload.details);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier,
                appName: payload.appName,
                page: payload.page
            });
        }
    }
    clientLogInfoMessageEvent(probeName, service, payload) {
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
    }
    serverLogErrorMessageEvent(probeName, service, payload) {
        service.action.logHelper.Logger.logError(payload.operation, payload.message, '');
        logger.error(payload.message, {
            action: payload.operation
        });
    }
    clientLogErrorMessageEvent(probeName, service, payload) {}
    serverLogOutRequestEvent(probeName, service, payload) {
        service.action.logHelper.Logger.ServerLogOutRequest(payload);
    }
    clientLogOutRequestEvent(probeName, service, payload) {
        service.action.pushRecordInBuffer(probeName, service, payload, false);
    }
    clientlogAndFlushOutRequestEvent(probeName, service, payload) {
        service.action.pushRecordInBuffer(probeName, service, payload, true);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    publishTelemetryEvent(telemetryPayload) {}
    pushRecordInBuffer(probeName, service, event, flushLog) {
        const record = {
            provider: 'shared',
            probe: probeName,
            time: new Date().getTime(),
            data: event
        };
        service.buffer.push(record);
        if (service.buffer.getSize() > service.maxBufferSize || flushLog) {
            service.action.loggerFlush(probeName, service);
        } else {
            // let's start a timer to flush the buffer
            // this will help safeguard against never reaching the maxBufferSize
            // and risk not storing anything at all
            service.action.startBufferTimer(probeName, service);
        }
    }
    startBufferTimer(probeName, service) {
        const window = getWindow();
        if (window) {
            const flushTimer = 30000; // 30 seconds
            if (this.timer) {
                window.clearTimeout(this.timer);
                this.timer = 0;
            }
            this.timer = window.setTimeout(()=>{
                // flush the buffer if we have anything in it
                if (service.buffer.getSize() > 0) {
                    service.action.loggerFlush(probeName, service);
                }
                this.timer = 0;
            }, flushTimer);
        }
    }
    constructor(isClient){
        super(), _define_property(this, "timer", 0), _define_property(this, "logHelper", null);
        if (!isClient) {
            this.logHelper = require('../../../../server/LogHelper');
        }
    }
}
export class SharedTelemetryService extends ConsumerService {
    registerProbes(isClient) {
        const p = this.instrumentService.getProvider('shared');
        if (p) {
            p.enableProbe('initSystemInfo', this, this.action.initSystemInfo);
            p.enableProbe('logTelemetryInfo', this, isClient ? this.action.clientLogInfoMessageEvent : this.action.serverLogInfoMessageEvent);
            p.enableProbe('logMessageError', this, isClient ? this.action.clientLogErrorMessageEvent : this.action.serverLogErrorMessageEvent);
            p.enableProbe('logOutRequestEventInfo', this, isClient ? this.action.clientLogOutRequestEvent : this.action.serverLogOutRequestEvent);
            p.enableProbe('logAndFlushOutRequestEventInfo', this, isClient ? this.action.clientlogAndFlushOutRequestEvent : this.action.serverLogOutRequestEvent);
            p.enableProbe('flushTelemetryInfo', this, isClient ? this.action.loggerFlush : ()=>{});
        }
    }
    constructor(instrumentService, isClient){
        super('shared telemetry', instrumentService), _define_property(this, "buffer", void 0), _define_property(this, "action", void 0), _define_property(this, "systemInfo", void 0), _define_property(this, "host", void 0), _define_property(this, "maxBufferSize", void 0);
        this.action = new TelemetryActions(isClient);
        if (instrumentService) {
            this.systemInfo = instrumentService.systemInfo;
        }
        if (isClient) {
            this.buffer = new Buffer(150);
            this.maxBufferSize = 20;
            this.aggregation = new AggregationBuffer();
        }
        this.registerProbes(isClient);
    }
}
